export type RatingScreenMode =
  | 'WORKPLACE_NOT_FOUND'
  | 'ABSENT_OPERATOR'
  | 'SCREENSAVER'
  | 'STANDBY'
  | 'IN_SERVICE'
  | 'AWAITING_RATING';

export type RatingType = 'STARS' | 'HEARTS' | 'NUMBERS';

export type RatingTicketPhase = 'CALL' | 'IN_PROGRESS' | 'COMPLETION';

export const RATING_TICKET_PHASES: { value: RatingTicketPhase; label: string; hint: string }[] = [
  { value: 'CALL', label: '1. Вызов', hint: 'Вызван по порядку, вне очереди, повторный вызов' },
  { value: 'IN_PROGRESS', label: '2. В работе', hint: 'В обработке' },
  { value: 'COMPLETION', label: '3. Завершение работы', hint: 'Обработан' }
];

export const IN_SERVICE_TICKET_PHASES = RATING_TICKET_PHASES.filter(
  (phase) => phase.value !== 'COMPLETION'
);

export const sanitizeInServicePhases = (
  phases: RatingTicketPhase[] | undefined
): RatingTicketPhase[] =>
  (phases ?? []).filter((phase) => phase !== 'COMPLETION');

export const sanitizeScreensaverPhases = (
  phases: RatingTicketPhase[] | undefined
): RatingTicketPhase[] =>
  (phases ?? []).filter((phase) => phase !== 'COMPLETION');

export type RatingBackgroundType = 'COLOR' | 'IMAGE';

export type RatingMediaDto = {
  id: number;
  url: string;
  mediaType: string;
  purpose: string;
};

export type RatingSettingsDto = {
  branchQueueId: number;
  ratingType: RatingType;
  textColor: string;
  transparentBackground: boolean;
  backgroundType: RatingBackgroundType;
  backgroundColor: string;
  backgroundMediaId: number | null;
  backgroundMediaUrl: string | null;
  showQr: boolean;
  showOperatorPhoto: boolean;
  qrUrl: string | null;
  qrLabelText: string;
  ratingTimeoutSeconds: number;
  extensionCountdownSeconds: number;
  thankYouSeconds: number;
  screensaverIdleSeconds: number;
  screensaverImageSeconds: number;
  screensaverMedia: RatingMediaDto[];
  backgrounds: RatingMediaDto[];
  inServicePhases: RatingTicketPhase[];
  ratingPhases: RatingTicketPhase[];
  screensaverPhases: RatingTicketPhase[];
  ratingPromptText: string;
  ratingScaleHint: string;
  thankYouText: string;
};

export type RatingStateDto = {
  screenMode: RatingScreenMode;
  serviceUnitId?: number;
  branchQueueId?: number;
  branchId?: number;
  sessionKey?: string;
  operator?: {
    id: number;
    fullName: string;
    photoUrl?: string | null;
  };
  ticket?: {
    itemId: number;
    ticketNumber: string;
    number: number;
    statusTime: string;
    phase: RatingTicketPhase;
  };
  settings?: RatingSettingsDto;
};

export type RatingWorkplaceParams = {
  branch: number;
  queue: string;
  cabinet: number | null;
  window: number | null;
};
